import { SxProp } from 'src/types/mui';

export const containerStyles: SxProp = theme => ({
  padding: 2,
  border: theme.constantStyles?.paperBorder,
  borderRadius: 2,
  backgroundColor: theme.palette.common.white,
});
